export type LiabilityType =
  | "home_loan"
  | "personal_loan"
  | "car_loan"
  | "credit_card"
  | "education_loan"
  | "other";

export interface UserLiability {
  id: string;
  user_id: string;
  liability_type: LiabilityType;
  name: string;
  outstanding_balance: number;
  interest_rate?: number | null;
  lender?: string | null;
  account_number?: string | null;
  notes?: string | null;
  metadata?: Record<string, unknown>;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface CreateLiabilityRequest {
  user_id: string;
  liability_type: LiabilityType;
  name: string;
  outstanding_balance: number;
  interest_rate?: number;
  lender?: string;
  account_number?: string;
  notes?: string;
  metadata?: Record<string, unknown>;
}

export interface UpdateLiabilityRequest {
  liability_type?: LiabilityType;
  name?: string;
  outstanding_balance?: number;
  interest_rate?: number;
  lender?: string;
  account_number?: string;
  notes?: string;
  metadata?: Record<string, unknown>;
  is_active?: boolean;
}

export const LIABILITY_TYPE_LABELS: Record<LiabilityType, string> = {
  home_loan: "Home Loan",
  personal_loan: "Personal Loan",
  car_loan: "Car Loan",
  credit_card: "Credit Card",
  education_loan: "Education Loan",
  other: "Other Debt",
};
